/* tslint:disable */
/* eslint-disable */
/**
 * MachineGo P1 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CheckUserModel,
    CheckUserModelFromJSON,
    CheckUserModelToJSON,
    ErrorModel,
    ErrorModelFromJSON,
    ErrorModelToJSON,
} from '../models';

export interface AuthCheckUserPostRequest {
    checkUserModel?: CheckUserModel;
}

/**
 * 
 */
export class AuthApi extends runtime.BaseAPI {

    /**
     */
    async authCheckUserPostRaw(requestParameters: AuthCheckUserPostRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/auth/check-user`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CheckUserModelToJSON(requestParameters.checkUserModel),
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async authCheckUserPost(requestParameters: AuthCheckUserPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<boolean> {
        const response = await this.authCheckUserPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
